import React from 'react'
import styled from 'styled-components'
import { injectState } from 'freactal'
import UnstyledContentSection from '../../../components/ContentSection'
import { getSectionHeading } from '../../../lib'
import TransformedImage from '../../../components/TransformedImage'
import ImageThumbnail from '../../../components/ImageThumbnail'

const Container = styled.div`
  position: relative;
  display: inline-block;
  border: 1px solid grey;
  width: 25.4cm;
  height: 19.05cm;
  background-color: #121f3b;
`
const WhiteSpace = styled.div`
  background-color: white;
  width: 23.8cm;
  height: 16cm;
  position: absolute;
  left: 1.6cm;
  border-top-left-radius: 1cm;
`
const Header = styled.div`
  position: relative;
  left: 2.5cm;
  display: flex;
  align-items: center;
  height: 3.5cm;
  color: #f2f2f2;
  line-height: 1.05em;
  font-weight: bold;
  font-size: 32pt;
`
const ContentSection = styled(UnstyledContentSection)`
  position: absolute;
  top: 1cm;
  left: 1cm;
  * {
    font-size: 16pt;
    line-height: 1.5em;
  }
  ul,
  ol {
    margin: 0;
  }
  width: ${({ image, imageWidth, imageAlignment = 'right' }) =>
    24.4 - (!image || imageAlignment === 'center' ? 0 : imageWidth + 0.8)}cm;
`
const ImageContainer = styled.div`
  margin-top: 0.5cm;
  margin-left: auto;
  margin-right: auto;
  width: ${({ imageWidth }) => imageWidth}cm;
  position: absolute;
  bottom: 0.5cm;
  ${({ imageAlignment = 'right' }) =>
    imageAlignment === 'center'
      ? `
    left: 25%;
    right: 25%`
      : 'right: .5cm'};
`
const Image = styled(TransformedImage)`width: 100%;`

class Slide extends React.Component {
  shouldComponentUpdate(nextProps) {
    const { unit, slide, useThumbnail } = nextProps
    if (
      this.props.unit === unit &&
      this.props.slide === slide &&
      this.props.useThumbnail === useThumbnail
    ) {
      return false
    }
    return true
  }

  render() {
    const { state: { unit }, slide, useThumbnail, ...restProps } = this.props
    const { image, content, sectionIndex } = slide
    const { display: { width = 5.5, align = 'right' } = {} } = image || {}
    return (
      <Container {...restProps}>
        <Header>
          <span>{getSectionHeading(unit, sectionIndex)}</span>
        </Header>
        <WhiteSpace>
          <ContentSection
            content={content}
            image={image}
            imageWidth={width}
            imageAlignment={align}
          />
          {image && (
            <ImageContainer imageWidth={width} imageAlignment={align}>
              {useThumbnail ? (
                <ImageThumbnail imageId={image.mediaId} />
              ) : (
                <Image image={image} />
              )}
            </ImageContainer>
          )}
        </WhiteSpace>
      </Container>
    )
  }
}

export default injectState(Slide)



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/ELearningPresentationContent/Slide.js